module.exports = __webpack_public_path__ + "img/source_gf-con.2ca342ff.png";